var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('v-loader',{attrs:{"loading":_vm.loading}}):_vm._l((_vm.contracts),function(c){return _c('v-contract-revision',{key:c.id,attrs:{"contract":c}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }